import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

export default function BreadCrumbs({ crumbs = [] }) {
    const navigate = useNavigate()

    return (
        <nav className='flex items-center flex-wrap gap-x-1.5 text-sm'>
            {crumbs.map((crumb, index) => {
                const isLastCrumb = index === crumbs.length - 1
                return (
                    <Fragment key={index}>
                        <button
                            className={`
                                cursor-pointer hover:underline font-normal 
                                ${isLastCrumb ? 'text-gray-900' : 'text-gray-500 hover:text-gray-600'}
                            `}
                            onClick={() => navigate(crumb.path, { state: crumb.state })}
                        >
                            {crumb.name}
                        </button>

                        {!isLastCrumb && <span className='text-gray-400'>/</span>}
                    </Fragment>
                )
            })}
        </nav>
    )
}
